/**
 * XML Modifier for SWIFT MX Messages
 * Modifies the original SWIFT XML with optimal route information
 * Handles both single and multi-message XML files
 */

export const modifySwiftXML = (originalXml, optimalRoute) => {
  if (!originalXml || !optimalRoute) {
    throw new Error('Missing XML content or optimal route data');
  }

  // Use string-based modification to handle multi-message XML reliably
  let modifiedXml = originalXml;

  // Add optimal route comment after first <CdtTrfTxInf> tag
  const commentText = `<!-- OPTIMAL ROUTE SELECTED: ${optimalRoute.cb_bic} via ${optimalRoute.corridor} | Cost: $${optimalRoute.cost} | Time: ${optimalRoute.avg_time_hours}h | SLA: ${(optimalRoute.sla_score * 100).toFixed(0)}% | Risk: ${optimalRoute.risk} | Liquidity: ${optimalRoute.liquidity} | GPI: ${optimalRoute.gpi === 1 ? 'Yes' : 'No'} -->`;

  const txnTag = '<CdtTrfTxInf>';
  const txnIndex = modifiedXml.indexOf(txnTag);
  if (txnIndex !== -1) {
    modifiedXml = modifiedXml.slice(0, txnIndex) + commentText + '\n' + modifiedXml.slice(txnIndex);
  }

  // Update CdtrAgt BICFI with optimal route CB_BIC
  const cdtrAgtPattern = /<CdtrAgt>\s*<FinInstnId>\s*<BICFI>([^<]+)<\/BICFI>/;
  const match = modifiedXml.match(cdtrAgtPattern);
  if (match) {
    modifiedXml = modifiedXml.replace(
      cdtrAgtPattern,
      `<CdtrAgt><FinInstnId><BICFI>${optimalRoute.cb_bic}</BICFI>`
    );
  }

  return modifiedXml;
};
